import { over } from "lodash";

export const styleSheet = () => ({
  pageRoot: {
    marginTop: "0px",
    backgroundColor: "#efefef",
    minHeight: "100vh",
  },
  mDisplay: {
    width: "100%",
    display: "flex",
    backgroundColor: "#efefef",
  },
  mWidth_15: {
    width: "15%",
    height: "100%",
    overflowY: "auto",
    backgroundColor: "#fff",
    // position: "fixed",
    position: "sticky",
    top: "70px",
  },
  mWidth_85: {
    // position: "relative",
    // left: "25%",
    width: "85%",
    backgroundColor: "#efefef",
    padding: "10px 20px",
    border: "1px solid lightgrey",
  },
  mainStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "60px 0px",
    position: "relative",
    borderBottom: "1px dashed lightgrey",
    height: "0px",
    overflow: "visible",
  },
  mColor: {
    backgroundColor: "#ededed",
  },
  mCanvas: {
    display: "block",
    margin: "auto",
  },
  mPosition: {
    position: "relative",
    marginBottom: "30px",
    // boxShadow: "-4px 0 0 0 #2868D7",
  },
  mButtonStyle: {
    background: "#2868D7 !important",
    borderRadius: "20px !important",
    fontWeight: "400 !important",
    textTransform: "capitalize !important",
    fontSize: "14px  !important",
    color: "#ffffff !important",
    padding: "7px 30px !important",
    margin: "10px 0 !important",
    border: "1px solid transparent !important", // Reserve space for border
    boxSizing: "border-box",
    width: "230px",
    "&:hover": {
      background: "#2868D7", // Keep same background
      border: "1px solid #2868D7 !important", // Outer border
      boxShadow: "inset 0 0 0 2px #ffffff", // Inner spacing line (white)
      color: "#ffffff",
    },

    "&:disabled": {
      background: "#8babe3 !important",
      cursor: "not-allowed",
    },
  },
  mAccordianColor: {
    background: "#f6f6f6 !important",
  },
  tabBarArea: {
    position: "sticky",
    top: 0,
    backgroundColor: "#f6f6f6",
    "& .MuiAccordionDetails-root": {
      backgroundColor: "#f6f6f6 !important",
    },
    "& .MuiButtonBase-root": {
      paddingRight: "6px !important",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,.05) !important",
      },
    },
    "& .Mui-expanded": {
      margin: "0 !important",
    },
  },
  mAccordianDetails: {
    backgroundColor: "#fff",
    padding: "0 !important",
  },
  mAccordianTxt: {
    textAlign: "center",
    paddingTop: "10px",
    position: "relative",
  },
  pageNumber: {
    position: "absolute",
    bottom: "8px",
    left: "32px",
    fontSize: "12px",
    fontWeight: "500",
    color: "#252b33",
  },
  mAccordianImage: {
    margin: "auto",
    width: "60px",
    borderLeft: "2px solid #2868D7 !important",
    cursor: "pointer",
  },
  mActive: {
    border: "2px solid #2868D7 !important",
  },
  transactionDetailSection: {
    padding: "16px",
    border: "2px solid  #2868D7 !important",
    backgroundColor: "#E4EAF4 !important",
  },
  transactionDetailHead: {
    fontSize: "13px !important",
    textAlign: "center !important",
    color: "#767486 !important",
    fontWeight: "400 !important",
    "& span": {
      fontWeight: "600 !important",
      color: "black !important",
    },
    "& a": {
      fontWeight: "600 !important",
      color: "#2868D7 !important",
      marginLeft: "12px",
      cursor: "pointer",
      "&:hover": {
        textDecoration: "underline !important",
      },
    },
  },
  transactionContTop: {
    color: "#767486 !important",
    fontWeight: "500 !important",
    fontSize: "13px !important",
    textAlign: "center !important",
  },
  transactionContBottom: {
    fontWeight: "600 !important",
    color: "black !important",
    fontSize: "13px !important",
    textAlign: "center !important",
  },
  subHeaderSec: {
    position: "sticky",
    top: 64,
    zIndex: 999,
    height: "60px !important",
    backgroundColor: "white !important",
    display: "flex !important",
    justifyContent: "space-between !important",
    alignItems: "center !important",
    // marginTop: "-3px",
    borderTop: "1px solid #E6E6E6",
  },
  subHeaderTitle: {
    fontSize: "14px  !important",
    color: "#767486  !important",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  subHeaderTitleArea: {
    maxWidth: "220px",
  },
  subHeaderBack: {
    width: "60px",
    height: "60px",
    backgroundColor: "#2868D7",
    display: "flex !important",
    justifyContent: "center!important",
    alignItems: "center !important",
    color: "white !important",
    cursor: "pointer !important",
    padding: "15px !important",
  },
  subHeaderLeft: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "center !important",
    gap: "12px !important",
  },
  subHeaderRight: {
    paddingRight: "16px",
    display: "flex !important",
    justifyContent: "flex-end !important",
    alignItems: "center !important",
    gap: "12px !important",
  },
  headerButton: {
    borderRadius: "20px !important",
    textTransform: "capitalize !important",
    backgroundColor: "#2868D7 !important",
    color: "white !important",
    width: "100px !important",
  },
  sideBarDocName: {
    display: "-webkit-box !important",
    "-webkit-line-clamp": "2 !important",
    "-webkit-box-orient": "vertical !important",
    overflow: "hidden !important",
    fontSize: "10px !important",
  },
  subHeaderCenter: {
    "& .MuiTab-label": {
      textTransform: "capitalize !important",
    },
  },
  peopleSection: {
    margin: "50px 30px",
    padding: "24px",
    minHeight: "200px",
    background: "white",
    borderTop: "4px solid #1448b0",
  },
  fieldSection: {
    margin: "50px 30px",
    padding: "70px 50px",
    minHeight: "200px",
    background: "white",
  },
  historySection: {
    margin: "50px 30px",
    padding: "50px",
    minHeight: "200px",
    background: "white",
  },
  historyAreaItem: {
    borderLeft: "4px solid #4cd4a0",
    padding: "8px",
  },
  historyHeader: {
    backgroundColor: "#4cd4a0",
    padding: "5px",
  },
  historyHeaderContent: {
    color: "white !important",
  },
  historyArea: {
    padding: "5px",
    marginTop: "12px",
  },
  peopleItemRow: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    alignItems: "center !important",
    gap: "10px",
    marginTop: "10px !important",
  },
  peopleBelowSection: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "16px !important",
  },
  peopleSectionItemLabel: {
    color: "#9f9fa3 !important",
    fontSize: "14px !important",
  },
  SectionFields: {
    display: "flex !important",
    justifyContent: "flex-start !important",
    gap: "6px",
    width: "100%",
    backgroundColor: "#eeeeed !important",
    border: "1px solid #e2e2e1 !important",
    padding: "1px",
    flexWrap: "wrap",
  },
  SectionFieldsItem: {
    backgroundColor: "#a2c8ed !important",
    height: "26px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0px 4px",
    gap: "10px",
  },
  buttonSection: {
    display: "flex",
    justifyContent: "flex-end",
    marginTop: "30px",
  },
  pageHeading: {
    borderBottom: "2px solid #1448b0",
  },
  fieldItemLabel: {
    color: "#9f9fa3 !important",
    fontSize: "14px !important",
  },
  fieldsSection: {
    display: "flex !important",
    flexDirection: "column !important",
    gap: "20px !important",
    marginTop: "20px !important",
  },
  fieldSectionPage: {
    marginBottom: "20px !important",
  },
  dateContent: {
    fontSize: "14px !important",
    marginTop: "6px !important",
    color: "#9b9b9e !important",
  },
  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },
  modalHeading: {
    fontSize: "20px !important",
    fontWeight: "600 !important",
    color: "black !important",
    textTransform: "capitalize !important",
  },
  inputLabel: {
    color: "#9f9fa3 !important",
    fontSize: "14px !important",
    textTransform: "capitalize !important",
  },
  transactionContainer: {
    width: "890px !important",
    margin: "0 auto !important",
  },
  documentContainer: {
    display: "flex !important",
    flexDirection: "row !important",
    alignItems: "flex-start !important",
  },
  documentContainerLeft: {
    width: "180px !important",
    position: "sticky",
    top: 60,
    height: "100vh",
    alignSelf: "flex-start",
    overflow: "auto",
    scrollbarWidth: "none", // Firefox
    msOverflowStyle: "none", // IE & Edge
    backgroundColor: "#f6f6f6",
    paddingTop: "0px !important",
    borderRight: "solid 1px rgba(0, 0, 0, 0.04)",
    "&::-webkit-scrollbar": {
      display: "none", // Chrome, Safari, Opera
    },
  },
});
